import { useState } from "react";
import {
  FaBuilding,
  FaChalkboardTeacher,
  FaChevronLeft,
  FaChevronRight,
  FaLaptop,
  FaTimes,
  FaUsers,
} from "react-icons/fa";

import "./DeliverySection.css";
import classroom1 from "../../assets/trainings/classroom/classroom-training1.jpg";
import classroom2 from "../../assets/trainings/classroom/classroom-training2.jpg";
import hybrid1 from "../../assets/trainings/hybrid/hybrid-training1.jpg";
import onsite1 from "../../assets/trainings/onsite/onsite-training1.jpg";
import onsite2 from "../../assets/trainings/onsite/onsite-training2.jpg";
import onsite3 from "../../assets/trainings/onsite/onsite-training3.jpg";
import remote1 from "../../assets/trainings/remote/remote-training1.jpg";

const deliveryItems = [
  {
    title: "Classroom Training",
    icon: <FaChalkboardTeacher />,
    images: [classroom1, classroom2],
  },
  {
    title: "Corporate Onsite Training",
    icon: <FaBuilding />,
    images: [onsite1, onsite2, onsite3],
  },
  {
    title: "Live Remote Training",
    icon: <FaLaptop />,
    images: [remote1],
  },
  {
    title: "Hybrid Training Programs",
    icon: <FaUsers />,
    images: [hybrid1],
  },
];

function DeliverySection() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const openCarousel = (item) => {
    setSelectedItem(item);
    setActiveIndex(0);
  };

  const closeCarousel = () => {
    setSelectedItem(null);
    setActiveIndex(0);
  };

  const nextImage = () => {
    setActiveIndex((previous) =>
      previous === selectedItem.images.length - 1 ? 0 : previous + 1
    );
  };

  const previousImage = () => {
    setActiveIndex((previous) =>
      previous === 0 ? selectedItem.images.length - 1 : previous - 1
    );
  };

  return (
    <section className="delivery" id="delivery">
      <div>
        <p className="eyebrow">Flexible Delivery</p>
        <h2>Training delivery for local and international teams</h2>
        <p>
          Trainosys supports organizations through flexible learning formats
          suitable for regional teams, distributed teams, and international
          participants.
        </p>
      </div>

      <div className="delivery-list">
        {deliveryItems.map((item) => (
          <button
            key={item.title}
            type="button"
            className="delivery-card"
            onClick={() => openCarousel(item)}
          >
            <div className="delivery-icon">{item.icon}</div>
            <span>{item.title}</span>
          </button>
        ))}
      </div>

      {selectedItem && (
        <div className="delivery-modal">
          <div className="delivery-modal-content">
            <button
              type="button"
              className="delivery-modal-close"
              onClick={closeCarousel}
            >
              <FaTimes />
            </button>
            <h3>{selectedItem.title}</h3>
            <div className="delivery-carousel">
              <button type="button" onClick={previousImage}>
                <FaChevronLeft />
              </button>
              <img
                src={selectedItem.images[activeIndex]}
                alt={selectedItem.title}
              />
              <button type="button" onClick={nextImage}>
                <FaChevronRight />
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default DeliverySection;
